module.exports = [{
      plugin: require('/tmp/6750bc6e/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
